export enum BucketMarkerVisualType {
  BlueBubble = 'BlueBubble',
  MultiColorBubble = 'MultiColorBubble',
  GrowingPin = 'GrowingPin',
  SameSizePin = 'SameSizePin',
}
